import { useState, useCallback } from 'react';

export const useComparison = (maxComparisons = 3) => {
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [showComparison, setShowComparison] = useState(false);

  const addToComparison = useCallback((vendor) => {
    setSelectedVendors(prev => {
      if (prev.find(v => v.id === vendor.id)) {
        return prev; // Already in comparison
      }
      if (prev.length >= maxComparisons) {
        return prev; // Max limit reached
      }
      return [...prev, vendor];
    });
  }, [maxComparisons]);

  const removeFromComparison = useCallback((vendorId) => {
    setSelectedVendors(prev => prev.filter(v => v.id !== vendorId));
  }, []);

  const toggleComparison = useCallback((vendor) => {
    setSelectedVendors(prev => {
      const isSelected = prev.find(v => v.id === vendor.id);
      if (isSelected) {
        return prev.filter(v => v.id !== vendor.id);
      }
      if (prev.length >= maxComparisons) {
        return prev;
      }
      return [...prev, vendor];
    });
  }, [maxComparisons]);

  const clearComparison = useCallback(() => {
    setSelectedVendors([]);
    setShowComparison(false);
  }, []);

  const openComparison = useCallback(() => {
    setShowComparison(true);
  }, []);

  const closeComparison = useCallback(() => {
    setShowComparison(false);
  }, []);

  const isSelected = useCallback((vendorId) => {
    return selectedVendors.some(v => v.id === vendorId);
  }, [selectedVendors]);

  const canAddMore = selectedVendors.length < maxComparisons;
  const canCompare = selectedVendors.length >= 2;

  return {
    selectedVendors,
    showComparison,
    addToComparison,
    removeFromComparison,
    toggleComparison,
    clearComparison,
    openComparison,
    closeComparison,
    isSelected,
    canAddMore,
    canCompare,
    maxComparisons
  };
};